import { Typography, Box, useTheme, TextField, Button, Grid, Dialog, DialogTitle, DialogContent, DialogActions, Autocomplete } from "@mui/material";
import React, { useState, useEffect } from "react";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { tokens } from "../theme/theme";
import { callApi } from "../utils/apiClient";
import { API_ENDPOINTS } from "../config/api/apiCall";
import CallAlertBar from "./Alertbar";

// hook call process
import useDepartment from "../hooks/useDepartment";
import useEmployeeByDepartmentID from "../hooks/useEmployeeByDepartment";
import useApproveEmployeeByDepartmentID from "../hooks/useApproveEmployeeByDepartmentID";

const AmentApproveRequest = ({ onClose, handleBackWinderMachineEntry, open, documentNumber, documentID, departmentID, requesterID, module, mode, requestID, approverID, reason }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // message call 
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const [amentReason, setAmentReason] = useState('');    
    const [disableSave, setDisableSave] = useState(false);

    // hooks call concept
    const { department, selectedDepartment, selectedDepartmentID, setSelectedDepartment, setSelectedDepartmentID, loadDepartmentByID } = useDepartment(0);
    const { employee, selectedEmployee, selectedEmployeeID, setSelectedEmployee, setSelectedEmployeeID, loadEmployeeByID } = useEmployeeByDepartmentID();
    const { approvalEmployee, selectedApprovalEmployee, selectedApprovalEmployeeID, setSelectedApprovalEmployee, setSelectedApprovalEmployeeID, loadApprovalEmployeeByID, } = useApproveEmployeeByDepartmentID();


    const callback = () => {
        handleBackWinderMachineEntry();
    };

    useEffect(() => {
        if (departmentID && departmentID !== 0) {
            (async () => {
                await loadDepartmentByID(departmentID);
                await loadEmployeeByID(requesterID, departmentID);
            })();
        }
    }, [departmentID, requesterID]);


    useEffect(() => {
        if (selectedDepartmentID && selectedDepartmentID !== 0 && mode === 0) {
            (async () => {
                await loadApprovalEmployeeByID(selectedApprovalEmployeeID, selectedDepartmentID);
            })();
        }
    }, [selectedDepartmentID, selectedApprovalEmployeeID]); // Added selectedEmployeeID to the dependency array


    // load edit mode detail
    useEffect(() => {

        if (mode === 1) {
            (async () => {
                await loadDepartmentByID(departmentID);
                await loadEmployeeByID(requesterID, departmentID);
                await loadApprovalEmployeeByID(approverID, departmentID);
                setAmentReason(reason);
            })();

        }

    }, [mode, requestID])


    const handleSaveOperator = () => {

        setParentRollMsgOpen(false);
        // validation 
        let isValid = true;
        let validation_msg = '';

        if (documentNumber === '') {
            validation_msg += 'Document number not valid.\n';
            isValid = false;
        }

        if (departmentID === '') {
            validation_msg += 'Department value not found.\n';
            isValid = false;
        }

        if (selectedEmployeeID === 0) {
            validation_msg += 'Requester value not found.\n';
            isValid = false;
        }
        if (selectedApprovalEmployeeID === 0) {
            validation_msg += 'Request to value not found.\n';
            isValid = false;
        }
        if (amentReason === '') {
            validation_msg += 'Ament reason not found.\n';
            isValid = false;
        }

        if (isValid) {
            const SaveData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_id_department: selectedDepartmentID,
                p_id_requested_by: selectedEmployeeID,
                p_id_approved_by: selectedApprovalEmployeeID,
                p_ament_request_reason: amentReason,
                p_module: module,
                p_id_document: documentID,
                p_document_number: documentNumber,
                p_mode: mode,
                p_id_ament_request:requestID,
            }

            callApi(API_ENDPOINTS.REQUEST_APPROVAL_FOR_AMENT_PROCESS, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {                        
                        toast.success('Approval Request Sent Successfully.', { position: toast.POSITION.BOTTOM_CENTER });
                        setDisableSave(true);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
        else {

            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }


    };



    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >


            <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                <Box display="flex" alignItems="center">
                    <Typography>Send Ament Request</Typography>
                </Box>
            </DialogTitle>

            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                
                <Box marginBottom={2}>{/* Your modal content here */}

                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Grid container spacing={2} sx={{ width: '100%', p: 1 }} >

                        <Grid item xs={12} sm={12} md={8} lg={12} xl={12}  >
                            <Grid container padding="10px 0px 5px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={2.5} lg={3} xl={3} display="flex-start" justifyContent="center">                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Document Number
                                </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={9} xl={9}>
                                    <TextField required value={documentNumber} fullWidth size="small" label="" variant="outlined" />
                                </Grid>
                            </Grid>
                        </Grid>


                        <Grid item xs={12} sm={12} md={8} lg={12} xl={12}  >
                            <Grid container padding="0px 0px 5px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={2.5} lg={3} xl={3} display="flex-start" justifyContent="center">                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Department
                                </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={9} xl={9}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={department}
                                        value={selectedDepartment}
                                        // disabled={editRequestIndentID !== 0}
                                        onChange={(event, newValue) => {
                                            setSelectedDepartment(newValue);
                                            setSelectedDepartmentID(newValue.id);
                                            // loadIndentNumbersByDepartmentID(newValue.id, selectionMode === 0 ? 'request indent' : 'approve indent');

                                        }}
                                        getOptionLabel={(option) => option.description || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={8} lg={12} xl={12}  >
                            <Grid container padding="0px 0px 5px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={2.5} lg={3} xl={3} display="flex-start" justifyContent="center">                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Request By
                                </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={9} xl={9}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={employee}
                                        value={selectedEmployee}
                                        onChange={(event, newValue) => {
                                            setSelectedEmployee(newValue);
                                            setSelectedEmployeeID(newValue.id_employee);
                                        }}
                                        getOptionLabel={(option) => option.employee_name || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={8} lg={12} xl={12}  >
                            <Grid container padding="0px 0px 5px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={2.5} lg={3} xl={3} display="flex-start" justifyContent="center">                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Request To
                                </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={9} xl={9}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        options={approvalEmployee}
                                        value={selectedApprovalEmployee}
                                        onChange={(event, newValue) => {
                                            setSelectedApprovalEmployee(newValue);
                                            setSelectedApprovalEmployeeID(newValue.id_employee);
                                        }}
                                        getOptionLabel={(option) => option.employee_name || ''}
                                        renderInput={(params) => (
                                            <TextField {...params} label="" required variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={12} md={8} lg={12} xl={12}  >
                            <Grid container padding="0px 0px 5px 0px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center" >
                                <Grid item xs={12} sm={12} md={2.5} lg={3} xl={3} display="flex-start" justifyContent="center">                                    <Typography variant="h6" fontSize={14} marginTop={0} textAlign="left">
                                    Ament Reason
                                </Typography>
                                </Grid>

                                <Grid item xs={12} sm={11} md={3.8} lg={9} xl={9}>
                                    <TextField required multiline value={amentReason} onChange={(e) => { setAmentReason(e.target.value) }} fullWidth size="small" label="" variant="outlined" />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>

            <DialogActions style={{ backgroundColor: colors.primary[400] }}>
                <Box display="flex" justifyContent="flex-end">

                    <Button onClick={handleSaveOperator} disabled={disableSave} size="small" variant="contained" color="success" startIcon={<CheckCircleOutlineIcon />} >
                        {mode === 0 ? 'Send Request' : 'Approve Request'}
                    </Button>

                    <Button size='small' onClick={onClose} variant="outlined" color="error" startIcon={<CancelOutlinedIcon />} style={{ textTransform: 'none', marginLeft: '10px' }} >
                        Cancel Requeat
                    </Button>
                </Box>

            </DialogActions>
        </Dialog>
    );
};
export default AmentApproveRequest;